// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatbotLayout.css */

:root {
    --colore-primario: #041c36; /* Blu acceso per bottoni e interazioni */
    --colore-sfondo: #c5e1fd; /* Sfondo chiaro */
    --colore-testo: #333; /* Testo scuro */
    --colore-sfondo-chat: #ffffff; /* Sfondo del corpo principale */
    --colore-risposta-ia: #e9ecef; /* Sfondo per le risposte IA */
    --larghezza-cronologia: 20%;
    --larghezza-contenuto: 60%;
    --larghezza-mantenute: 20%;
    --header-height: 100px;
}

button {
    border:none;

}
table{
    border:none;
    padding:0cap;
    border-spacing: 0cap;
    
}
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    background-color: var(--colore-sfondo);
    color: var(--colore-testo);
}

/* Struttura principale a griglia */
.app-container {
    display: grid;
    grid-template-areas:
        "headerc header headerm"
        "cronologia contenuto mantenute";
    grid-template-columns: var(--larghezza-cronologia) var(--larghezza-contenuto) var(--larghezza-mantenute);
    grid-template-rows: var(--header-height) 1fr;
    height: 100vh;
}

/* Intestazione (Prompt Input) */
.header-input {
    grid-area: header;
    background-color: var(--colore-sfondo-chat);
    padding: 15px 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 10px;
}

.prompt-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s;
}

.prompt-input:focus {
    border-color: var(--colore-primario);
    outline: none;
}

.send-button {
    background-color: var(--colore-primario);
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-weight: bold;
}

.send-button:hover {
    background-color: #0f365f;
}

/* Colonne laterali (Cronologia e Mantenute) */
.colonna-laterale {
    padding: 20px;
    overflow-y: auto;
    border-right: 1px solid #ddd;
}

.cronologia-container   {
    grid-area: cronologia;
    background-color: #ffffff;
    border-right: 1px solid #e0e0e0;
}
.headerm-container {
    grid-area: headerm;
    background-color: #ffffff;
    border-right: 1px solid #e0e0e0;
    scroll-behavior: none;
    scrollbar-width: none;
}
.headerc-container {
    grid-area: headerc;
    background-color: #ffffff;
    border-right: 1px solid #e0e0e0;
    scroll-behavior: none;
        scroll-behavior: none;
    scrollbar-width: none;
}

.mantenute-container {
    grid-area: mantenute;
    background-color: #ffffff;
    border-left: 1px solid #e0e0e0;
}

.colonna-laterale h3 {
    margin-top: 0;
    font-size: 0.8em;
    color: var(--colore-primario);
    
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 2px solid var(--colore-primario);
    margin-bottom: 15px;
}

.cronologia-item, .mantenuta-item {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 6px;
    background-color: var(--colore-sfondo);
    cursor: pointer;
    font-size: 0.8em;
    white-space: normal;
    overflow: auto;
    text-overflow: ellipsis;
}

.cronologia-item:hover, .mantenuta-item:hover {
    background-color: #e0e0e0;
}

.clear-button {
    background: none;
    border: 1px solid var(--colore-primario);
    color: var(--colore-primario);
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.8em;
    transition: all 0.3s;
}

.clear-button:hover {
    background-color: var(--colore-primario);
    color: white;
}

/* Contenuto Principale (Risposte) */
.contenuto-principale {
    grid-area: contenuto;
    padding: 20px;
    overflow-y: auto;
    position: relative; /* Necessario per la filigrana */
    background-color: var(--colore-sfondo-chat);
}

/* Filigrana Logo */
.filigrana-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.1; /* Effetto filigrana */
    z-index: 0;
    font-size: 150px; /* Grande per l'effetto */
    color: var(--colore-primario);
    pointer-events: none; /* Non interferisce con il click */
}

/* Stile per le Risposte */
.risposte-lista {
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 1; /* Sopra la filigrana */
    position: relative;
    /* --- Gestione Scroll --- */
}

.risposta-item {
    background-color: var(--colore-risposta-ia);
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.user-prompt {
    font-weight: bold;
    color: #495057;
    margin-bottom: 8px;
    border-bottom: 1px dashed #ced4da;
    padding-bottom: 5px;
}

.response-content {
    white-space: pre-wrap;
    margin-bottom: 10px;

    
}

.user-info-bar{
    vertical-align: text-top;
    
}

.response-actions button {
    background: none;
    border: none; /*1px solid #6c757d;*/
    color: #6c757d;
    padding: 8px 15px;
    margin-right: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s;
    
}

.response-actions .copy-btn:hover {
    background-color: var(--colore-primario);
    color: white;
    
   /* border-color: var(--colore-primario);*/
}

.response-actions .delete-btn:hover {
    background-color: #dc3545;
    color: white;
    /*border-color: #dc3545;*/
}

.response-actions .keep-btn:hover {
    background-color: #28a745;
    color: white;
    border-color: #28a745;
}

/* Aggiungi al tuo file CSS (cb.css) */

/* Stile per le chat attive */
.cronologia-item.active-chat {
    background-color: #e0f7fa; /* Un colore chiaro per evidenziare */
    border-left: 5px solid var(--colore-primario);
    padding-left: 5px;
}

/* Contenitore per i pulsanti di azione (Rinomina/Cancella) nella lista chat */
.cronologia-item {
    display: flex; /* Permette allineamento a riga */
    justify-content: space-between;
    align-items: center;
    /* ... altri stili esistenti ... */
}

.chat-actions {
    display: flex;
    gap: 5px;
}

.cronologia-item .action-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.8em;
    padding: 2px;
    opacity: 0.6;
    transition: opacity 0.2s;
}

.cronologia-item .action-btn:hover {
    opacity: 1;
    background-color: #ddd;
    border-radius: 3px;
}

/* Stile per il campo di editing del titolo */
.chat-edit-container {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
}

/* --- AGGIUNTE PER PAGINA DI LOGIN --- */

/* Contenitore Pagina */
.login-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--colore-sfondo); /* Sfondo chiaro */
}

/* Scatola Login Centrata */
.login-box {
    background-color: var(--colore-sfondo-chat); /* Sfondo bianco/chiaro */
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px; /* Larghezza fissa per il form */
    text-align: center;
    position: relative;
    overflow: hidden;
}

/* Titolo App */
.app-title {
    color: var(--colore-primario);
    margin-bottom: 20px;
    font-size: 2em;
}

/* Filigrana nel Login Box */
.auth-logo-filigrana {
    position: absolute;
    top: 10px;
    right: 10px;
    opacity: 0.05; 
    font-size: 100px;
    color: var(--colore-primario);
    pointer-events: none;
    z-index: 0;
}

/* Campi di Input */
.auth-input {
    width: calc(100% - 24px); 
    padding: 12px;
    margin: 10px 0 20px 0;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s;
    text-align: center;
}

.auth-input:focus {
    border-color: var(--colore-primario);
    outline: none;
}

/* Bottone Primario (Login / Invia Codice) */
.auth-button {
    width: 100%;
    background-color: var(--colore-primario);
    color: white;
    border: none;
    padding: 12px 0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    transition: background-color 0.3s;
    margin-bottom: 15px;
}

.auth-button:hover {
    background-color: #0056b3;
}

/* Bottone Secondario (Cambia Email) */
.secondary-button {
    width: 100%;
    background: none;
    color: #6c757d;
    border: 1px solid #6c757d;
    padding: 10px 0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
}

.secondary-button:hover {
    color: var(--colore-primario);
    border-color: var(--colore-primario);
}

/* Messaggi di Errore */
.error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 20px;
}

/* Stile per il caricamento */
.loading-state {
    padding: 20px;
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid var(--colore-primario);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
    margin: 0 auto 10px auto;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* --- AGGIUNTE PER FORM DI CONFIGURAZIONE --- */

.config-form-container {
    padding: 20px;
    background-color: var(--colore-sfondo-chat);
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    max-width: 800px;
    margin: 20px auto;
}

.config-form-container h2 {
    color: var(--colore-primario);
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr; /* Due colonne */
    gap: 20px;
    margin-bottom: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group label {
    font-weight: bold;
    color: #495057;
    margin-bottom: 5px;
    font-size: 0.9em;
}

.form-group input,
.form-group textarea {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1em;
    transition: border-color 0.3s;
    background-color: #f8f9fa;
}

.form-group input:focus,
.form-group textarea:focus {
    border-color: var(--colore-primario);
    outline: none;
    background-color: white;
}

.full-width {
    grid-column: 1 / -1; /* Occupa entrambe le colonne */
}

/* Stile specifico per il campo lungo del Prompt */
.form-group textarea {
    min-height: 120px;
    resize: vertical;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    padding-top: 10px;
    border-top: 1px dashed #eee;
}

/* Stile per il bottone di salvataggio (primario) */
.save-button {
    background-color: #28a745; /* Verde per Salva */
    color: white;
    border: none;
    padding: 10px 25px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1em;
    font-weight: bold;
    transition: background-color 0.3s;
}

.save-button:hover {
    background-color: #1e7e34;
}

/* Stile per il bottone di annulla (secondario) */
.cancel-button {
    background-color: #6c757d; /* Grigio per Annulla */
    color: white;
    border: none;
    padding: 10px 25px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1em;
    font-weight: bold;
    transition: background-color 0.3s;
}

.cancel-button:hover {
    background-color: #5a6268;
}

/* --- AGGIUNTE PER MENU AMMINISTRATORE (DA INSERIRE IN App.jsx <style>) --- */

.admin-panel-container {
    padding: 40px;
    margin: 20px auto;
    max-width: 1000px;
    background-color: var(--colore-sfondo-chat);
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.admin-panel-container h1 {
    color: #495057;
    border-bottom: 1px solid #ddd;
    padding-bottom: 15px;
}

.tab-bar {
    display: flex;
    gap: 10px;
}

.tab-button {
    padding: 10px 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: none;
    color: #6c757d;
    transition: color 0.3s, border-bottom 0.3s;
    border-bottom: 3px solid transparent;
}

.tab-button.active {
    color: var(--colore-primario);
    border-bottom: 3px solid var(--colore-primario);
}

/* Stili per le Card Azione (Utenti/Chat) */
.bg-blue-500 { background-color: #bcccdd; }
.hover\\:bg-blue-600:hover { background-color: #eff0f1; }
.bg-red-500 { background-color: #dc3545; }
.hover\\:bg-red-600:hover { background-color: #c82333; }
.bg-green-500 { background-color: #28a745; }
.hover\\:bg-green-600:hover { background-color: #1e7e34; }

/* Stili per la tabella di gestione (Tailwind utility simulate) */
.bg-gray-50 { background-color: #f9fafb; }
.text-gray-700 { color: #495057; }
.text-gray-500 { color: #6c757d; }
.text-gray-900 { color: #1f2937; }
.bg-green-100 { background-color: #d4edda; }
.text-green-800 { color: #155724; }
.bg-red-100 { background-color: #f8d7da; }
.text-red-800 { color: #721c24; }
.bg-blue-50 { background-color: #e9f7ff; }
.border-blue-200 { border-color: #b8daff; }

/* Utility di base */
.p-4 { padding: 1rem; }
.mb-4 { margin-bottom: 1rem; }
.mb-6 { margin-bottom: 1.5rem; }
.rounded-xl { border-radius: 0.75rem; }
.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }
.cursor-pointer { cursor: pointer; }
.flex { display: flex; }
.items-center { align-items: center; }
.space-x-4 > * + * { margin-left: 1rem; }
.space-x-3 > * + * { margin-left: 0.75rem; }
.space-x-2 > * + * { margin-left: 0.5rem; }
.space-y-3 > * + * { margin-top: 0.75rem; }
.font-semibold { font-weight: 600; }
.text-lg { font-size: 1.125rem; }
.text-sm { font-size: 0.875rem; }
.text-3xl { font-size: 1.875rem; }
.opacity-90 { opacity: 0.9; }
.grid { display: grid; }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.gap-6 { gap: 1.5rem; }
.gap-4 { gap: 1rem; }

/* Table styles */
.min-w-full { min-width: 100%; }
.divide-y > * + * { border-top-width: 1px; }
.divide-gray-200 { border-color: #e5e7eb; }
.whitespace-nowrap { white-space: nowrap; }
.tracking-wider { letter-spacing: 0.05em; }
.uppercase { text-transform: uppercase; }
.text-xs { font-size: 0.75rem; }
.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }
.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
.text-left { text-align: left; }
.text-center { text-align: center; }
.rounded-lg { border-radius: 0.5rem; }
.shadow { box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); }

/* Buttons */
.save-button, .cancel-button {
    /* Manteniamo gli stili definiti nel form precedente per coerenza */
    /* Assicurati che questi stili siano già presenti o aggiungili: */
    padding: 10px 25px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    border: none;
    color: white;
}

/* Specifiche del componente */
.bg-green-600 { background-color: #1e8449; }
.hover\\:bg-green-700:hover { background-color: #145a32; }
.bg-blue-600 { background-color: #007bff; }
.hover\\:bg-blue-700:hover { background-color: #0056b3; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.px-4 { padding-left: 1rem; padding-right: 1rem; }
.rounded-full { border-radius: 9999px; }

.transition { transition: all 0.15s ease-in-out; }

.language-selector-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}
.language-selector-container select {
    padding: 5px;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/cb.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,0BAA0B,EAAE,yCAAyC;IACrE,wBAAwB,EAAE,kBAAkB;IAC5C,oBAAoB,EAAE,gBAAgB;IACtC,6BAA6B,EAAE,gCAAgC;IAC/D,6BAA6B,EAAE,8BAA8B;IAC7D,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;;AAEf;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;;AAExB;AACA;IACI,SAAS;IACT;;cAEU;IACV,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb;;wCAEoC;IACpC,wGAAwG;IACxG,4CAA4C;IAC5C,aAAa;AACjB;;AAEA,gCAAgC;AAChC;IACI,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,qBAAqB;QACjB,qBAAqB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;;IAE7B,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,kBAAkB,EAAE,gCAAgC;IACpD,2CAA2C;AAC/C;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY,EAAE,sBAAsB;IACpC,UAAU;IACV,gBAAgB,EAAE,yBAAyB;IAC3C,6BAA6B;IAC7B,oBAAoB,EAAE,kCAAkC;AAC5D;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,UAAU,EAAE,uBAAuB;IACnC,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;;;AAGvB;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,gBAAgB;IAChB,YAAY,EAAE,qBAAqB;IACnC,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;;AAExB;;AAEA;IACI,wCAAwC;IACxC,YAAY;;GAEb,yCAAyC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,sCAAsC;;AAEtC,6BAA6B;AAC7B;IACI,yBAAyB,EAAE,qCAAqC;IAChE,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA,8EAA8E;AAC9E;IACI,aAAa,EAAE,iCAAiC;IAChD,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA,yCAAyC;;AAEzC,uBAAuB;AACvB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sCAAsC,EAAE,kBAAkB;AAC9D;;AAEA,2BAA2B;AAC3B;IACI,2CAA2C,EAAE,yBAAyB;IACtE,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX,gBAAgB,EAAE,gCAAgC;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;IACxB,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,4CAA4C;IAC5C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,gDAAgD;;AAEhD;IACI,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B,EAAE,gBAAgB;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;IACpC,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB,EAAE,+BAA+B;AACxD;;AAEA,kDAAkD;AAClD;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,mDAAmD;AACnD;IACI,yBAAyB,EAAE,oBAAoB;IAC/C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iDAAiD;AACjD;IACI,yBAAyB,EAAE,uBAAuB;IAClD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,8EAA8E;;AAE9E;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,+CAA+C;AACnD;;AAEA,2CAA2C;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,4BAA4B,yBAAyB,EAAE;AACvD,cAAc,yBAAyB,EAAE;AACzC,2BAA2B,yBAAyB,EAAE;AACtD,gBAAgB,yBAAyB,EAAE;AAC3C,6BAA6B,yBAAyB,EAAE;;AAExD,iEAAiE;AACjE,cAAc,yBAAyB,EAAE;AACzC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,gBAAgB,yBAAyB,EAAE;AAC3C,kBAAkB,cAAc,EAAE;AAClC,cAAc,yBAAyB,EAAE;AACzC,gBAAgB,cAAc,EAAE;AAChC,cAAc,yBAAyB,EAAE;AACzC,mBAAmB,qBAAqB,EAAE;;AAE1C,oBAAoB;AACpB,OAAO,aAAa,EAAE;AACtB,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;AAC/B,cAAc,sBAAsB,EAAE;AACtC,aAAa,mFAAmF,EAAE;AAClG,kBAAkB,eAAe,EAAE;AACnC,QAAQ,aAAa,EAAE;AACvB,gBAAgB,mBAAmB,EAAE;AACrC,qBAAqB,iBAAiB,EAAE;AACxC,qBAAqB,oBAAoB,EAAE;AAC3C,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,mBAAmB,EAAE;AAC1C,iBAAiB,gBAAgB,EAAE;AACnC,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;AAChC,YAAY,mBAAmB,EAAE;AACjC,cAAc,YAAY,EAAE;AAC5B,QAAQ,aAAa,EAAE;AACvB,eAAe,gDAAgD,EAAE;AACjE,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;;AAEpB,iBAAiB;AACjB,cAAc,eAAe,EAAE;AAC/B,oBAAoB,qBAAqB,EAAE;AAC3C,mBAAmB,qBAAqB,EAAE;AAC1C,qBAAqB,mBAAmB,EAAE;AAC1C,kBAAkB,sBAAsB,EAAE;AAC1C,aAAa,yBAAyB,EAAE;AACxC,WAAW,kBAAkB,EAAE;AAC/B,QAAQ,oBAAoB,EAAE,uBAAuB,EAAE;AACvD,QAAQ,iBAAiB,EAAE,oBAAoB,EAAE;AACjD,QAAQ,oBAAoB,EAAE,qBAAqB,EAAE;AACrD,aAAa,gBAAgB,EAAE;AAC/B,eAAe,kBAAkB,EAAE;AACnC,cAAc,qBAAqB,EAAE;AACrC,UAAU,2EAA2E,EAAE;;AAEvF,YAAY;AACZ;IACI,mEAAmE;IACnE,iEAAiE;IACjE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,YAAY;AAChB;;AAEA,8BAA8B;AAC9B,gBAAgB,yBAAyB,EAAE;AAC3C,6BAA6B,yBAAyB,EAAE;AACxD,eAAe,yBAAyB,EAAE;AAC1C,4BAA4B,yBAAyB,EAAE;AACvD,QAAQ,mBAAmB,EAAE,sBAAsB,EAAE;AACrD,QAAQ,kBAAkB,EAAE,mBAAmB,EAAE;AACjD,gBAAgB,qBAAqB,EAAE;;AAEvC,cAAc,iCAAiC,EAAE;;AAEjD;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["/* ChatbotLayout.css */\r\n\r\n:root {\r\n    --colore-primario: #041c36; /* Blu acceso per bottoni e interazioni */\r\n    --colore-sfondo: #c5e1fd; /* Sfondo chiaro */\r\n    --colore-testo: #333; /* Testo scuro */\r\n    --colore-sfondo-chat: #ffffff; /* Sfondo del corpo principale */\r\n    --colore-risposta-ia: #e9ecef; /* Sfondo per le risposte IA */\r\n    --larghezza-cronologia: 20%;\r\n    --larghezza-contenuto: 60%;\r\n    --larghezza-mantenute: 20%;\r\n    --header-height: 100px;\r\n}\r\n\r\nbutton {\r\n    border:none;\r\n\r\n}\r\ntable{\r\n    border:none;\r\n    padding:0cap;\r\n    border-spacing: 0cap;\r\n    \r\n}\r\nbody {\r\n    margin: 0;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n    background-color: var(--colore-sfondo);\r\n    color: var(--colore-testo);\r\n}\r\n\r\n/* Struttura principale a griglia */\r\n.app-container {\r\n    display: grid;\r\n    grid-template-areas:\r\n        \"headerc header headerm\"\r\n        \"cronologia contenuto mantenute\";\r\n    grid-template-columns: var(--larghezza-cronologia) var(--larghezza-contenuto) var(--larghezza-mantenute);\r\n    grid-template-rows: var(--header-height) 1fr;\r\n    height: 100vh;\r\n}\r\n\r\n/* Intestazione (Prompt Input) */\r\n.header-input {\r\n    grid-area: header;\r\n    background-color: var(--colore-sfondo-chat);\r\n    padding: 15px 20px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.prompt-input {\r\n    width: 100%;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    transition: border-color 0.3s;\r\n}\r\n\r\n.prompt-input:focus {\r\n    border-color: var(--colore-primario);\r\n    outline: none;\r\n}\r\n\r\n.send-button {\r\n    background-color: var(--colore-primario);\r\n    color: white;\r\n    border: none;\r\n    padding: 12px 20px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n    font-weight: bold;\r\n}\r\n\r\n.send-button:hover {\r\n    background-color: #0f365f;\r\n}\r\n\r\n/* Colonne laterali (Cronologia e Mantenute) */\r\n.colonna-laterale {\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    border-right: 1px solid #ddd;\r\n}\r\n\r\n.cronologia-container   {\r\n    grid-area: cronologia;\r\n    background-color: #ffffff;\r\n    border-right: 1px solid #e0e0e0;\r\n}\r\n.headerm-container {\r\n    grid-area: headerm;\r\n    background-color: #ffffff;\r\n    border-right: 1px solid #e0e0e0;\r\n    scroll-behavior: none;\r\n    scrollbar-width: none;\r\n}\r\n.headerc-container {\r\n    grid-area: headerc;\r\n    background-color: #ffffff;\r\n    border-right: 1px solid #e0e0e0;\r\n    scroll-behavior: none;\r\n        scroll-behavior: none;\r\n    scrollbar-width: none;\r\n}\r\n\r\n.mantenute-container {\r\n    grid-area: mantenute;\r\n    background-color: #ffffff;\r\n    border-left: 1px solid #e0e0e0;\r\n}\r\n\r\n.colonna-laterale h3 {\r\n    margin-top: 0;\r\n    font-size: 0.8em;\r\n    color: var(--colore-primario);\r\n    \r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-bottom: 10px;\r\n    border-bottom: 2px solid var(--colore-primario);\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.cronologia-item, .mantenuta-item {\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    border-radius: 6px;\r\n    background-color: var(--colore-sfondo);\r\n    cursor: pointer;\r\n    font-size: 0.8em;\r\n    white-space: normal;\r\n    overflow: auto;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.cronologia-item:hover, .mantenuta-item:hover {\r\n    background-color: #e0e0e0;\r\n}\r\n\r\n.clear-button {\r\n    background: none;\r\n    border: 1px solid var(--colore-primario);\r\n    color: var(--colore-primario);\r\n    padding: 5px 10px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 0.8em;\r\n    transition: all 0.3s;\r\n}\r\n\r\n.clear-button:hover {\r\n    background-color: var(--colore-primario);\r\n    color: white;\r\n}\r\n\r\n/* Contenuto Principale (Risposte) */\r\n.contenuto-principale {\r\n    grid-area: contenuto;\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    position: relative; /* Necessario per la filigrana */\r\n    background-color: var(--colore-sfondo-chat);\r\n}\r\n\r\n/* Filigrana Logo */\r\n.filigrana-logo {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    opacity: 0.1; /* Effetto filigrana */\r\n    z-index: 0;\r\n    font-size: 150px; /* Grande per l'effetto */\r\n    color: var(--colore-primario);\r\n    pointer-events: none; /* Non interferisce con il click */\r\n}\r\n\r\n/* Stile per le Risposte */\r\n.risposte-lista {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    z-index: 1; /* Sopra la filigrana */\r\n    position: relative;\r\n    /* --- Gestione Scroll --- */\r\n}\r\n\r\n.risposta-item {\r\n    background-color: var(--colore-risposta-ia);\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.user-prompt {\r\n    font-weight: bold;\r\n    color: #495057;\r\n    margin-bottom: 8px;\r\n    border-bottom: 1px dashed #ced4da;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.response-content {\r\n    white-space: pre-wrap;\r\n    margin-bottom: 10px;\r\n\r\n    \r\n}\r\n\r\n.user-info-bar{\r\n    vertical-align: text-top;\r\n    \r\n}\r\n\r\n.response-actions button {\r\n    background: none;\r\n    border: none; /*1px solid #6c757d;*/\r\n    color: #6c757d;\r\n    padding: 8px 15px;\r\n    margin-right: 10px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: all 0.3s;\r\n    \r\n}\r\n\r\n.response-actions .copy-btn:hover {\r\n    background-color: var(--colore-primario);\r\n    color: white;\r\n    \r\n   /* border-color: var(--colore-primario);*/\r\n}\r\n\r\n.response-actions .delete-btn:hover {\r\n    background-color: #dc3545;\r\n    color: white;\r\n    /*border-color: #dc3545;*/\r\n}\r\n\r\n.response-actions .keep-btn:hover {\r\n    background-color: #28a745;\r\n    color: white;\r\n    border-color: #28a745;\r\n}\r\n\r\n/* Aggiungi al tuo file CSS (cb.css) */\r\n\r\n/* Stile per le chat attive */\r\n.cronologia-item.active-chat {\r\n    background-color: #e0f7fa; /* Un colore chiaro per evidenziare */\r\n    border-left: 5px solid var(--colore-primario);\r\n    padding-left: 5px;\r\n}\r\n\r\n/* Contenitore per i pulsanti di azione (Rinomina/Cancella) nella lista chat */\r\n.cronologia-item {\r\n    display: flex; /* Permette allineamento a riga */\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    /* ... altri stili esistenti ... */\r\n}\r\n\r\n.chat-actions {\r\n    display: flex;\r\n    gap: 5px;\r\n}\r\n\r\n.cronologia-item .action-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 0.8em;\r\n    padding: 2px;\r\n    opacity: 0.6;\r\n    transition: opacity 0.2s;\r\n}\r\n\r\n.cronologia-item .action-btn:hover {\r\n    opacity: 1;\r\n    background-color: #ddd;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* Stile per il campo di editing del titolo */\r\n.chat-edit-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    width: 100%;\r\n}\r\n\r\n/* --- AGGIUNTE PER PAGINA DI LOGIN --- */\r\n\r\n/* Contenitore Pagina */\r\n.login-page-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background-color: var(--colore-sfondo); /* Sfondo chiaro */\r\n}\r\n\r\n/* Scatola Login Centrata */\r\n.login-box {\r\n    background-color: var(--colore-sfondo-chat); /* Sfondo bianco/chiaro */\r\n    padding: 40px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n    width: 100%;\r\n    max-width: 400px; /* Larghezza fissa per il form */\r\n    text-align: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Titolo App */\r\n.app-title {\r\n    color: var(--colore-primario);\r\n    margin-bottom: 20px;\r\n    font-size: 2em;\r\n}\r\n\r\n/* Filigrana nel Login Box */\r\n.auth-logo-filigrana {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    opacity: 0.05; \r\n    font-size: 100px;\r\n    color: var(--colore-primario);\r\n    pointer-events: none;\r\n    z-index: 0;\r\n}\r\n\r\n/* Campi di Input */\r\n.auth-input {\r\n    width: calc(100% - 24px); \r\n    padding: 12px;\r\n    margin: 10px 0 20px 0;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    transition: border-color 0.3s;\r\n    text-align: center;\r\n}\r\n\r\n.auth-input:focus {\r\n    border-color: var(--colore-primario);\r\n    outline: none;\r\n}\r\n\r\n/* Bottone Primario (Login / Invia Codice) */\r\n.auth-button {\r\n    width: 100%;\r\n    background-color: var(--colore-primario);\r\n    color: white;\r\n    border: none;\r\n    padding: 12px 0;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    transition: background-color 0.3s;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.auth-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n/* Bottone Secondario (Cambia Email) */\r\n.secondary-button {\r\n    width: 100%;\r\n    background: none;\r\n    color: #6c757d;\r\n    border: 1px solid #6c757d;\r\n    padding: 10px 0;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: all 0.3s;\r\n}\r\n\r\n.secondary-button:hover {\r\n    color: var(--colore-primario);\r\n    border-color: var(--colore-primario);\r\n}\r\n\r\n/* Messaggi di Errore */\r\n.error-message {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    border: 1px solid #f5c6cb;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* Stile per il caricamento */\r\n.loading-state {\r\n    padding: 20px;\r\n}\r\n\r\n.spinner {\r\n    border: 4px solid rgba(0, 0, 0, 0.1);\r\n    border-top: 4px solid var(--colore-primario);\r\n    border-radius: 50%;\r\n    width: 30px;\r\n    height: 30px;\r\n    animation: spin 1s linear infinite;\r\n    margin: 0 auto 10px auto;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* --- AGGIUNTE PER FORM DI CONFIGURAZIONE --- */\r\n\r\n.config-form-container {\r\n    padding: 20px;\r\n    background-color: var(--colore-sfondo-chat);\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\r\n    max-width: 800px;\r\n    margin: 20px auto;\r\n}\r\n\r\n.config-form-container h2 {\r\n    color: var(--colore-primario);\r\n    border-bottom: 2px solid #eee;\r\n    padding-bottom: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr; /* Due colonne */\r\n    gap: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.form-group label {\r\n    font-weight: bold;\r\n    color: #495057;\r\n    margin-bottom: 5px;\r\n    font-size: 0.9em;\r\n}\r\n\r\n.form-group input,\r\n.form-group textarea {\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 6px;\r\n    font-size: 1em;\r\n    transition: border-color 0.3s;\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group textarea:focus {\r\n    border-color: var(--colore-primario);\r\n    outline: none;\r\n    background-color: white;\r\n}\r\n\r\n.full-width {\r\n    grid-column: 1 / -1; /* Occupa entrambe le colonne */\r\n}\r\n\r\n/* Stile specifico per il campo lungo del Prompt */\r\n.form-group textarea {\r\n    min-height: 120px;\r\n    resize: vertical;\r\n}\r\n\r\n.form-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 15px;\r\n    padding-top: 10px;\r\n    border-top: 1px dashed #eee;\r\n}\r\n\r\n/* Stile per il bottone di salvataggio (primario) */\r\n.save-button {\r\n    background-color: #28a745; /* Verde per Salva */\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 25px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 1em;\r\n    font-weight: bold;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.save-button:hover {\r\n    background-color: #1e7e34;\r\n}\r\n\r\n/* Stile per il bottone di annulla (secondario) */\r\n.cancel-button {\r\n    background-color: #6c757d; /* Grigio per Annulla */\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 25px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 1em;\r\n    font-weight: bold;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.cancel-button:hover {\r\n    background-color: #5a6268;\r\n}\r\n\r\n/* --- AGGIUNTE PER MENU AMMINISTRATORE (DA INSERIRE IN App.jsx <style>) --- */\r\n\r\n.admin-panel-container {\r\n    padding: 40px;\r\n    margin: 20px auto;\r\n    max-width: 1000px;\r\n    background-color: var(--colore-sfondo-chat);\r\n    border-radius: 12px;\r\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.admin-panel-container h1 {\r\n    color: #495057;\r\n    border-bottom: 1px solid #ddd;\r\n    padding-bottom: 15px;\r\n}\r\n\r\n.tab-bar {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.tab-button {\r\n    padding: 10px 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    border: none;\r\n    background: none;\r\n    color: #6c757d;\r\n    transition: color 0.3s, border-bottom 0.3s;\r\n    border-bottom: 3px solid transparent;\r\n}\r\n\r\n.tab-button.active {\r\n    color: var(--colore-primario);\r\n    border-bottom: 3px solid var(--colore-primario);\r\n}\r\n\r\n/* Stili per le Card Azione (Utenti/Chat) */\r\n.bg-blue-500 { background-color: #bcccdd; }\r\n.hover\\:bg-blue-600:hover { background-color: #eff0f1; }\r\n.bg-red-500 { background-color: #dc3545; }\r\n.hover\\:bg-red-600:hover { background-color: #c82333; }\r\n.bg-green-500 { background-color: #28a745; }\r\n.hover\\:bg-green-600:hover { background-color: #1e7e34; }\r\n\r\n/* Stili per la tabella di gestione (Tailwind utility simulate) */\r\n.bg-gray-50 { background-color: #f9fafb; }\r\n.text-gray-700 { color: #495057; }\r\n.text-gray-500 { color: #6c757d; }\r\n.text-gray-900 { color: #1f2937; }\r\n.bg-green-100 { background-color: #d4edda; }\r\n.text-green-800 { color: #155724; }\r\n.bg-red-100 { background-color: #f8d7da; }\r\n.text-red-800 { color: #721c24; }\r\n.bg-blue-50 { background-color: #e9f7ff; }\r\n.border-blue-200 { border-color: #b8daff; }\r\n\r\n/* Utility di base */\r\n.p-4 { padding: 1rem; }\r\n.mb-4 { margin-bottom: 1rem; }\r\n.mb-6 { margin-bottom: 1.5rem; }\r\n.rounded-xl { border-radius: 0.75rem; }\r\n.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }\r\n.cursor-pointer { cursor: pointer; }\r\n.flex { display: flex; }\r\n.items-center { align-items: center; }\r\n.space-x-4 > * + * { margin-left: 1rem; }\r\n.space-x-3 > * + * { margin-left: 0.75rem; }\r\n.space-x-2 > * + * { margin-left: 0.5rem; }\r\n.space-y-3 > * + * { margin-top: 0.75rem; }\r\n.font-semibold { font-weight: 600; }\r\n.text-lg { font-size: 1.125rem; }\r\n.text-sm { font-size: 0.875rem; }\r\n.text-3xl { font-size: 1.875rem; }\r\n.opacity-90 { opacity: 0.9; }\r\n.grid { display: grid; }\r\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n.gap-6 { gap: 1.5rem; }\r\n.gap-4 { gap: 1rem; }\r\n\r\n/* Table styles */\r\n.min-w-full { min-width: 100%; }\r\n.divide-y > * + * { border-top-width: 1px; }\r\n.divide-gray-200 { border-color: #e5e7eb; }\r\n.whitespace-nowrap { white-space: nowrap; }\r\n.tracking-wider { letter-spacing: 0.05em; }\r\n.uppercase { text-transform: uppercase; }\r\n.text-xs { font-size: 0.75rem; }\r\n.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }\r\n.py-4 { padding-top: 1rem; padding-bottom: 1rem; }\r\n.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }\r\n.text-left { text-align: left; }\r\n.text-center { text-align: center; }\r\n.rounded-lg { border-radius: 0.5rem; }\r\n.shadow { box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); }\r\n\r\n/* Buttons */\r\n.save-button, .cancel-button {\r\n    /* Manteniamo gli stili definiti nel form precedente per coerenza */\r\n    /* Assicurati che questi stili siano già presenti o aggiungili: */\r\n    padding: 10px 25px;\r\n    border-radius: 8px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n    border: none;\r\n    color: white;\r\n}\r\n\r\n/* Specifiche del componente */\r\n.bg-green-600 { background-color: #1e8449; }\r\n.hover\\:bg-green-700:hover { background-color: #145a32; }\r\n.bg-blue-600 { background-color: #007bff; }\r\n.hover\\:bg-blue-700:hover { background-color: #0056b3; }\r\n.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }\r\n.px-4 { padding-left: 1rem; padding-right: 1rem; }\r\n.rounded-full { border-radius: 9999px; }\r\n\r\n.transition { transition: all 0.15s ease-in-out; }\r\n\r\n.language-selector-container {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n.language-selector-container select {\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
